import { PdfCellType } from './pdf-cell-type.enum';
import { Constants } from '../constants';
import { DateFormatPipe } from '../pipes/date-format.pipe';

export class PdfCell {

    text: string;
    style: string[];

    constructor(text: string, type?: PdfCellType, additionalStyles?: string[]) {
        this.style = [];
        if (!type) {
            type = PdfCellType.TEXT;
        }

        if (type === PdfCellType.TEXT) {
            this.style.push('textCell');
            this.text = text;
        } else if (type === PdfCellType.NUMBER) {
            this.style.push('numericCell');
            this.text = text;
        } else if (type === PdfCellType.DATE) {
            this.style.push('textCell');
            this.text = new DateFormatPipe(Constants.DATE_FORMAT_MMM_DD).transform(text);
        } else if (type === PdfCellType.HEADER) {
            this.text = text;
            this.style.push('headerTitle');
        }
        if (additionalStyles && additionalStyles.length > 0) {
            this.style = this.style.concat(additionalStyles);
        }
        if (!this.text || this.text === '') {
            this.text = Constants.PDF_EMPTY_CELL;
        }
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/shared/pdf/pdf-cell.ts